<template>
  <span />
</template>
<script>
import { mapGetters, mapActions } from "vuex";

export default {
  methods: {
    ...mapActions(["getUser"]),
  },
  computed: mapGetters(["isLogged", "user"]),
  async created() {
    await this.getUser();
    if (this.isLogged) {
      if (localStorage.getItem("userType") === "student") {
        if (this.user.get("getStartedDone")) {
          this.$router.push({ name: "StudentDashboard" });
        } else {
          this.$router.push({ name: "GetStarted" });
        }
      } else {
        this.$router.push({ name: "Dashboard" });
      }
    } else {
      const isCordova = typeof window !== "undefined" && !!window.cordova;
      this.$router.replace({ name: isCordova ? "Login" : "Signup" });
    }
  },
};
</script>
